export default "__VITE_ASSET__ChkEdzLI__"